module.exports = __webpack_public_path__ + "media/images/browser-logos/firefox-24a62096586e22784f9eccac3cc7a9d1.png";